// The design system's Wordmark: the Convenor mark (light and dark versions swap
// with the theme) and the name in Spectral, "Conven*or*." on the Convenor name;
// another app name is drawn plain. Screen readers get the app name, not the
// letters one by one.
import markOnDark from "@convenor/design-system/assets/convenor-mark-dark-bg.svg";
import mark from "@convenor/design-system/assets/convenor-mark.svg";
import { Link } from "react-router";
import { useMeta } from "../api/meta";

// The one allowed brand literal in UI code: the italic belongs to the Convenor name only.
const ITALIC_FOR = "Convenor";

export function Wordmark({ to }: { to?: string }) {
  const { appName } = useMeta();
  const body = (
    <>
      <img className="cv-mark--light" src={mark} alt="" />
      <img className="cv-mark--dark" src={markOnDark} alt="" />
      <span aria-hidden="true">
        {appName === ITALIC_FOR ? (
          <>
            {appName.slice(0, -2)}
            <i>{appName.slice(-2)}</i>
          </>
        ) : (
          appName
        )}
        .
      </span>
      <span className="visually-hidden">{appName}</span>
    </>
  );
  return to ? (
    <Link className="wordmark" to={to}>
      {body}
    </Link>
  ) : (
    <span className="wordmark">{body}</span>
  );
}
